import React, { useEffect, useState } from "react";
import CompanyCarousel from "./MiniComponents/CompanyCarousel/CompanyCarousel";
import BranchCarousel from "./MiniComponents/BranchCarousel/BranchCarousel";
import MainInfo from "./MiniComponents/MainInfo/MainInfo";
import FinancialInfo from "./MiniComponents/FinancialInfo/FinancialInfo";
import Introduction from "./MiniComponents/Introduction/Introduction";
import MaintenanceItems from "./MiniComponents/MaintenanceItems/MaintenanceItems";
import TermsSection from "./MiniComponents/TermsSection/TermsSection";
import ContractReview from "./MiniComponents/ContractReview/ContractReview";
import CarouselIndicators from "./MiniComponents/CarouselIndicators/CarouselIndicators";
import { useDispatch, useSelector } from "react-redux";
import { getContractById } from "../../../redux/contractSlice/contractSlice";
import { useParams } from "react-router-dom";
import Parties from "./MiniComponents/Parties/Parties";

export default function AddContract() {
  const { ContractId } = useParams();
  const dispatch = useDispatch();
  const { detailsContract } = useSelector((state) => state.contract);
  const [selectedCompany, setSelectedCompany] = useState({
    value: null,
    label: "",
  });
  const [selectedBranch, setSelectedBranch] = useState({
    value: null,
    label: "",
  });
  const [contract, setContract] = useState({
    branch_id: selectedBranch?.label,
    start_date: "",
    end_date: "",
    introduction: "لما كان الطرف الأول يرغب فى صيانة .... ، اتفق الطرفان و هما بكامل الأهلية المعتبرة نظاماً على ما يلي أن يقوم الطرف الثاني بصيانة .... التابع للطرف الأول وبياناتها كالتالي:-:-",
    value: null,
    maintenance_visits: null,
    payment_type: "full",
    installment_count: null,
    terms: [],
    first_party: "",
    second_party: "",
    clauses: [],
  });
  // useEffect(() => {
  //   console.log(detailsContract);
  // }, [detailsContract]);
  const [maintenanceItems, setMaintenanceItems] = useState([]);
  const [terms, setTerms] = useState([]);
  useEffect(() => {
    setContract((prev) => ({
      ...prev,
      clauses: maintenanceItems.map((m) => ({
        item: m.item,
        quantity: m.quantity,
      })),
    }));
  }, [maintenanceItems]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setContract((prevContract) => ({
      ...prevContract,
      [id]: value,
    }));
  };

  useEffect(() => {
    const isEdit = !!ContractId;

    if (isEdit) {
      dispatch(getContractById(ContractId));
    } else {
      const emptyContract = {
        branch_id: null,
        start_date: "",
        end_date: "",
        introduction: "لما كان الطرف الأول يرغب فى صيانة شبكتي إطفاء و إنذار الحريق ، اتفق الطرفان و هما بكامل الأهلية المعتبرة نظاماً على ما يلي :- أن يقوم الطرف الثاني بصيانة شبكة الإطفاء والإنذار للمحل التابع للطرف الأول وبياناتها كالتالي:-",
        value: null,
        maintenance_visits: null,
        payment_type: "full",
        installment_count: null,
        terms: [],
        first_party: "",
        second_party: "",
      };

      setContract(emptyContract);
      setSelectedBranch({ value: null, label: "" });
      setSelectedCompany({ value: null, label: "" });
      setTerms([]);
      setMaintenanceItems([]);
    }
  }, [ContractId, dispatch]);

  useEffect(() => {
    if (ContractId && detailsContract) {
      setContract(detailsContract);
      setSelectedBranch({ value: detailsContract.branch_id, label: detailsContract.branch?.name });
      setTerms(detailsContract?.terms);
      setMaintenanceItems(detailsContract?.clauses);
      console.log("xxxxxxxx", detailsContract?.maintenanceItems);
      setSelectedCompany({ value: detailsContract.branch?.company?.id, label: detailsContract.branch?.company?.name });
    }
  }, [ContractId, detailsContract]);

  return (
    <div className="main addContract">
      <div>
        <h1 className="text-white">اضافة عقد</h1>
      </div>
      <div className="card mt-5">
        <div id="carouselExampleIndicators" className="carousel slide ">
          {/* Carousel Indicators */}
          <CarouselIndicators />
          {/* Carousel Items */}
          <div className="carousel-inner">
            {/* Company Selection */}
            <CompanyCarousel selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} />
            {/* Branch Selection */}
            <BranchCarousel selectedCompany={selectedCompany} selectedBranch={selectedBranch} setSelectedBranch={setSelectedBranch} />

            {/* Main info */}
            <MainInfo handleInputChange={handleInputChange} contract={contract} />
            {/* Financial info */}
            <FinancialInfo handleInputChange={handleInputChange} contract={contract} />
            {/* introduction */}
            <Introduction contract={contract} handleInputChange={handleInputChange} />
            {/* Terms Section */}
            <TermsSection setTerms={setTerms} terms={terms} />
            {/* Maintenance Items */}
            <MaintenanceItems maintenanceItems={maintenanceItems} setMaintenanceItems={setMaintenanceItems} />
            {/* Contract Review */}
            <ContractReview selectedCompany={selectedCompany} setContract={setContract} contract={{ ...contract, terms: [...terms] }} maintenanceItems={maintenanceItems} terms={terms} selectedBranch={selectedBranch} />
          </div>
        </div>
      </div>
    </div>
  );
}
